import { render } from "./StepPreview.vue?vue&type=template&id=4b9ce97c&scoped=true"
import script from "./StepPreview.vue?vue&type=script&lang=js"
export * from "./StepPreview.vue?vue&type=script&lang=js"

import "./StepPreview.vue?vue&type=style&index=0&id=4b9ce97c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9ce97c"]])

export default __exports__